import React from "react";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SchoolRounded from '@mui/icons-material/School';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import VolunteerActivismRoundedIcon from '@mui/icons-material/VolunteerActivismRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { SiLinkedin, SiFacebook, SiYoutube, SiX } from "react-icons/si";


const options = {
    "meta": {
        "siteName": "Eigen X",
        "siteDescription": "Eigen X is a leading provider Data Analytics services. We specialize in assisting businesses with data visualization, data warehousing, and predictive analytics to help them make data-driven decisions.",
        "keywords": [
            "Data Analytics",
            "Tableau",
            "Power BI",
            "Snowflake",
            "Consulting",
            "Data Management",
            "Data Warehousing",
            "Digital Transformation",
            "Business Intelligence",
            "AI",
            "Machine Learning",
            "Predictive Analytics"
        ],
        "canonical": "https://portal.eigenx.com",
        "see_also": "https://eigenx.com",
        "disclaimer_html": "This site is governed solely by applicable U.S. laws and governmental regulations. Use of this site constitutes your consent to application of such laws and regulations and to our <a href=\"https://www.eigenx.com/policy\" target=\"_blank\">Privacy Policy</a>. Your use of the information on this site is subject to the <a href=\"https://www.eigenx.com/policy\" target=\"_blank\">Terms Of Use</a>. <a href=\"https://www.eigenx.com/contact-us\" target=\"_blank\">Contact Us</a> with any questions."
    },
    "categories": [
        "Education",
        "Finance",
        "Life Sciences",
        "Not for Profit",
        "Retail",
        "Other"
    ],
    "navigation": [
        {
            "name": "Home",
            "path": "/",
            "icon": <HomeRoundedIcon />
        },
        {
            "name": "Education",
            "path": "/education",
            "icon": <SchoolRounded />
        },
        {
            "name": "Finance",
            "path": "/finance",
            "icon": <AccountBalanceRoundedIcon />
        },
        {
            "name": "Life Sciences",
            "path": "/life-sciences",
            "icon": <ScienceRoundedIcon />
        },
        {
            "name": "Not for Profit",
            "path": "/not-for-profit",
            "icon": <VolunteerActivismRoundedIcon />
        },
        {
            "name": "Retail",
            "path": "/retail",
            "icon": <StorefrontRoundedIcon />
        },
        {
            "name": "Other",
            "path": "/other",
            "icon": <CategoryRoundedIcon />
        }
    ],
    "contact": [
        // {
        //     "type": "phone",
        //     "name": "Call Us",
        //     "value": "+1 (855) 344-3690",
        //     "icon": <LocalPhoneRoundedIcon sx={{ color: "var(--x-logo-color)", transition: "color 0.25s ease-in-out" }} />
        // },
        {
            "type": "link",
            "name": "Email Us",
            "value": "https://www.eigenx.com/contact-us",
            "icon": <EmailRoundedIcon sx={{ color: "var(--x-logo-color)", transition: "color 0.25s ease-in-out" }} />
        },
        {
            "type": "link",
            "name": "LinkedIn",
            "value": "https://linkedin.com/company/eigenxllc",
            "icon": <SiLinkedin color="var(--linkedin-color)" style={{ transition: "color 0.25s ease-in-out"}} />
        },
        {
            "type": "link",
            "name": "Facebook",
            "value": "https://www.facebook.com/eigenxllc/",
            "icon": <SiFacebook color="var(--facebook-color)" style={{ transition: "color 0.25s ease-in-out"}} />
        },
        {
            "type": "link",
            "name": "YouTube",
            "value": "https://www.youtube.com/channel/UC2I7hX8_TSXqLnj6sadTZYA",
            "icon": <SiYoutube color="var(--youtube-color)" style={{ transition: "color 0.25s ease-in-out"}} />
        },
        {
            "type": "link",
            "name": "X",
            "value": "https://x.com/eigenx",
            "icon": <SiX color="var(--x-logo-color)" style={{ transition: "color 0.25s ease-in-out" }} />
        }
    ]
}

export default options;